import type { Ranges } from 'api/System/types'
import type { Moment } from 'moment'
import { useSelector } from 'react-redux'
import type { State } from 'store/types'
import { getMomentDate } from 'utils'

function useSelectedRangeText(fromDate: Ranges, date: Moment | null) {
  const ranges = useSelector((state: State) => state.system.ranges)
  const selectedRange = ranges.find(
    ({ end, range, start }) => range === fromDate && moment(start).isSameOrBefore(date) && moment(end).isSameOrAfter(date),
  )
  const endDate = Math.min(date?.valueOf() || moment().valueOf(), moment(selectedRange?.end).valueOf())

  return selectedRange?.start ? `${getMomentDate(selectedRange.start).format('L')} - ${getMomentDate(endDate).format('L')}` : '-'
}

export default useSelectedRangeText
